import AppModal from "../../AppModal";
import AppModalActions from "../../AppModal/AppModalActions";
import AppButton from "../../AppButton";
import "./PlatformDeleteModal.css";
import AppModalContent from "../../AppModal/AppModalContent";

interface PlatformDeleteModalProps {
  isVisible: boolean;
  setIsModalVisible: (visible: boolean) => void;
  onConfirmDelete: (country: string | null) => void;
  selectedCountry: string | null;
  platform?: boolean;
}

const PlatformDeleteModal: React.FC<PlatformDeleteModalProps> = ({
  isVisible,
  setIsModalVisible,
  onConfirmDelete,
  selectedCountry,
  platform = false,
}) => {
  const handleConfirm = () => {
    onConfirmDelete(selectedCountry);
    setIsModalVisible(false);
  };

  return (
    <AppModal
      isVisible={isVisible}
      onChange={() => {
        setIsModalVisible(!isVisible);
      }}
      className="content-delete-modal"
    >
      <AppModalContent>
        <div className="content-delete-modal-body">
          <div className="content-delete-modal-title">
            Do you really want to delete this {platform ? "platform" : "app"}?
          </div>
          <p>
            Please note that you will lose all activity and usage data for this{" "}
            {platform ? "platform" : "app"}.
          </p>
        </div>
      </AppModalContent>
      <AppModalActions>
        <div className="content-delete-actions">
          <AppButton
            variant="yellow"
            fullWidth
            onClick={() => setIsModalVisible(false)}
          >
            Close
          </AppButton>
          <AppButton variant="red" fullWidth onClick={handleConfirm}>
            Yes
          </AppButton>
        </div>
      </AppModalActions>
    </AppModal>
  );
};

export default PlatformDeleteModal;
